<template> 
<div>
    <Form ref="form" :model="form" :rules="formRules" :label-position="myConfig.labelPosition" :label-width="myConfig.labelWidth" :inline="myConfig.inline" :id="myConfig.name" @submit.native.prevent>
        <Row type="flex" justify="start">
            <Col v-for="(item,index) in items" v-if="item.status" :span="initFormItemCol(index)" v-show="item.visible !== false" >
                <FormItem v-if="item.type !== 'Divider' && item.status && item.visible !== false" :label="item.label" :prop="item.name||item.sname"  :style="getFormItemStyle(item)" :show-message="false">
                    <ControlBox  :ref="item.name||item.sname"  :valueData="form" :config="item" @input="input"   @doAction="doAction" ></ControlBox>
                </FormItem>
                <ControlBox  v-if="item.type === 'Divider'" :config="item"></ControlBox>
            </Col>
        </Row>
    </Form>
</div>
</template>
<script>
    import Base from './baseform.vue';
    export default {
        name: 'FormBox',
        extends: Base,
        created () {
            this.init();
        },
        methods:{
            
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/form/formbox.vue